import React from "react";
import { FormButton } from "components";
import XGrid from "components/UI/Grid/XGrid";
import { agenteHistorialTitles as titles } from "consts/titulos-de-tablas";
import { labelDeAccion } from "consts/acciones-historial";
import { transformDate } from "services/Local-services";
import { etiquetaEstado } from "../consts";
import styles from "./HistorialModal.module.scss";

/**
 * Historial de lugares del agente. Es AUDITORÍA y es de SOLO LECTURA.
 *
 * Muestra TODOS los movimientos, sin filtrar ninguno: asignaciones, modificaciones y
 * desasignaciones. Ese es el punto. La tabla del detalle responde "dónde trabaja hoy";
 * esta responde "qué pasó, cuándo y quién lo hizo", y para eso una modificación vale
 * tanto como una baja.
 *
 * Antes las desasignaciones se mezclaban en la tabla del detalle y el resto se
 * descartaba. Eso tenía dos problemas: escondía la mitad de la historia, y un lugar que
 * se desasignó y se volvió a asignar aparecía dos veces en la misma tabla —una como
 * vigente y otra como pasado— sin forma de distinguirlas.
 *
 * El orden lo da el back: del más reciente al más antiguo. No se reordena acá.
 *
 * Lo que todavía le falta para ser una auditoría completa es QUIÉN hizo cada
 * movimiento. Ver la nota en `filasDeHistorial`.
 */

function comoArray(valor) {
  let v = valor;
  if (typeof v === "string") {
    try {
      v = JSON.parse(v);
    } catch {
      return [];
    }
  }
  return Array.isArray(v) ? v : [];
}

export function filasDeHistorial(agente) {
  return comoArray(agente?.rnhAgenteLugaresHistorial).map((h, i) => ({
    id: `${h.rnhAgenteLugarId ?? "s"}-${h.rnhAgenteLugarHistFH ?? "s"}-${i}`,
    fecha: h.rnhAgenteLugarHistFH ? transformDate(h.rnhAgenteLugarHistFH) : "",
    accion: labelDeAccion(h.rnhAgenteLugarHistAccion),
    lugar: h.rnhAgenteLugarNombre ?? "",
    hospital: h.rnhAgenteLugarHospitalNombre ?? "",
    funcion: h.rnhAgenteLugarFuncion || "Sin función",
    cargo: h.rnhAgenteLugarCargo === "Y" ? "Sí" : "—",
    status: etiquetaEstado(h.rnhAgenteLugarStatusCod),
  }));
}

export default function HistorialModal({ datosAgente, closeModal }) {
  const filas = filasDeHistorial(datosAgente);

  return (
    <div className={styles.contenedor}>
      
      <div className={styles.tabla}>
        <XGrid rows={filas} titles={titles} />
      </div>

      <FormButton oneButton closeButtonText="Cerrar" onCloseModal={closeModal} />
    </div>
  );
}
